webpackJsonp([221635269911418],{

/***/ 2020:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"StockTransferRequestEdge","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"cursor","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"node","type":{"kind":"OBJECT","name":"StockTransferRequest","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-stock-transfer-request-edge-a838b35b76cbd095af41.js